import SerieTamisFormController from './serie.tamis.form.controller';

export default {
    template: require('./serie.tamis.form.html'),
    controller: SerieTamisFormController
};
